import React from 'react';
import { Alert, Box, Button, MenuItem, Pagination, TextField, Typography } from '@mui/material';
import { ShowcaseProductViewSelector } from '../../../../components/SelectedPresentation/ShowcaseProductViews';

export default function ShowcaseProductPagination({ browse, controls = true, view, onViewChange }) {
  const { pagination } = browse.data || {};
  const disabled = browse.loading || browse.mutating || browse.editorOpen;
  return <Box sx={{ display: 'grid', gap: 1.5 }}>
    {controls && <Box sx={{ display: 'flex', gap: 1.5, alignItems: 'center', flexWrap: 'wrap', minWidth: 0 }}>
      <TextField size="small" label="Search website products" value={browse.criteria.q}
        disabled={browse.editorOpen || browse.mutating}
        onChange={event => browse.changeCriteria({ q: event.target.value })}
        placeholder="Name, SKU or supplier" sx={{ flex: '1 1 220px', minWidth: 0 }} />
      <Typography variant="body2" role="status" aria-live="polite" sx={{ color: 'text.secondary' }}>
        {browse.loading ? 'Loading products…' : pagination
          ? `Displaying ${pagination.from.toLocaleString()}–${pagination.to.toLocaleString()} of ${pagination.total.toLocaleString()} product${pagination.total === 1 ? '' : 's'}`
          : 'No product page loaded'}
      </Typography>
      <TextField select size="small" label="Products per page" value={browse.criteria.rpp} disabled={disabled}
        onChange={event => browse.changeCriteria({ rpp: Number(event.target.value) })} sx={{ minWidth: 145 }}>
        {[24, 48, 96].map(size => <MenuItem key={size} value={size}>{size}</MenuItem>)}
      </TextField>
      {view && <ShowcaseProductViewSelector view={view} onChange={onViewChange} orderingAvailable={false} compact />}
    </Box>}
    {controls && browse.error && <Alert severity="error" action={<Button onClick={browse.reload}>Retry</Button>}>
      {browse.error} {pagination ? 'Previously loaded products are still shown.' : ''}
    </Alert>}
    <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', flexWrap: 'wrap' }}>
      {pagination && <Box component="nav" aria-label={`Website products pagination (${controls ? 'top' : 'bottom'})`}
        sx={{ display: 'flex', gap: 1, alignItems: 'center', flexWrap: 'wrap' }}>
        <Button variant="outlined" size="small" disabled={disabled || !pagination.hasPrevious}
          onClick={() => browse.changeCriteria({ page: pagination.page - 1 })}>Previous</Button>
        <Pagination count={pagination.totalPages} page={pagination.page} hidePrevButton hideNextButton disabled={disabled}
          onChange={(_event, page) => browse.changeCriteria({ page })} aria-label="Website products pages" />
        <Button variant="outlined" size="small" disabled={disabled || !pagination.hasNext}
          onClick={() => browse.changeCriteria({ page: pagination.page + 1 })}>Next</Button>
      </Box>}
    </Box>
    {controls && browse.editorOpen && <Alert severity="info">Save or close the product editor before changing pages or search.</Alert>}
    {controls && <Typography variant="caption" color="text.secondary">
      Custom products can be edited here. Use Catalogues to hide or show catalogue products.
    </Typography>}
  </Box>;
}
